import { InputMask, InputMaskProps } from 'primereact/inputmask';
import { withFormControl } from '../with-form-control';

export const FormInputMask = withFormControl<InputMaskProps>((props) => {
  return <InputMask {...props} />;
});
